import type { TranslationDict } from './ja'

export const zhHans: TranslationDict = {
  appTitle: '幸运动物地盘战',
  help: '玩法',
  helpAria: '玩法',
  settings: '设置',
  settingsAria: '设置',
  close: '关闭',
  closeAria: '关闭',
  player: '玩家',
  highscore: '最高分',
  start: '开始游戏',
  staminaEmpty: '体力不足',
  ranking: '大家的地盘战',
  difficultyTitle: '选择难度',
  difficultyStart: '以此难度开始',
  back: '返回',
  today: '今天',
  weekly: '本周',
  alltime: '总榜',
  loading: '读取中...',
  noScores: '还没有战绩。来成为第一位地盘王！',
  loadFailed: '读取失败',
  you: '你',
  youConstant: '你',
  language: '语言',
  languageNote: '支持包含日语在内的18种语言。',
  bgm: 'BGM',
  se: '音效',
  soundEnableAria: '打开声音',
  soundDisableAria: '关闭声音',
  adWatch: '看完整个广告',
  adCancel: '暂不',
  rankSuffix: '名',
  earnedPoints: '获得 {score}pt',
  helpGoalTitle: '🎯 游戏目的',
  helpGoalText: '在 9x9 的棋盘上交替放置棋子，扩张自己的领地（同色棋子群）。最终得分高的玩家获胜。',
  helpWinTitle: '🏆 胜利条件',
  helpWinFive: '在横、竖、斜任意方向连成 5 个同色棋子即可立即获胜',
  helpWinScore: '棋盘填满后通过得分高低决定胜负（无平局）',
  helpScoreTitle: '💯 得分规则',
  helpLineBonus: '连线奖励：每当达成 3 连、4 连或 5 连时获得加分',
  helpClusterBonus: '领地奖励：根据连接在一起的棋子群的大小获得加分',
  helpKomi: '贴目：后手方可获得得分 +10% 的补偿分',
  helpControlsTitle: '🖱️ 操作说明',
  helpControlsText: '轮到你的回合时，点击棋盘上的空位即可放置棋子。',
  helpTipsTitle: '💡 小提示',
  helpTipHell: '想要挑战自我，请尝试最难的 HELL 难度',
  helpTipCluster: '不仅要追求 5 连，扩大棋子群也是提高得分的关键',
  resultWinFive: '🎉 达成 5 连！你赢了！',
  resultWinScore: '🎉 分数胜出！你获得了完胜！',
  resultLoseFive: '😿 CPU 达成 5 连... 你输了。',
  resultLoseScore: '😿 分数落后... 下次加油！',
  resultDraw: '🤝 平局',
  newHighscore: '🏆 刷新最高分！',
  scoreNone: '暂无分数',
  clusterBonus: '棋子群奖励',
  retry: '再玩一次',
  titleBack: '返回标题',
  scoreHintPlaceStone: '请落子',
  best: '最高',
  clusterUnit: '个群体',
  lineCount: '{len}连 x{count}',
  turnCount: '第 {count} 手 · {difficulty}',
  boardPlayerPiece: '你的棋子',
  boardCpuPiece: 'CPU 的棋子',
  boardPlayerAlt: '你',
  boardCpuAlt: 'CPU',
  boardCellPosition: '第 {row} 行，第 {col} 列',
  boardPlaceable: '可放置',
  boardEmpty: '空格',
  boardFlower: '有花',
  firstPlayerAlt: '先手',
  playerFirst: '你是先手！',
  playerSecond: '你是后手（获得 +{bonus}% 贴目奖励）',
  cpuFirst: 'CPU 是先手！',
  finalePlayerWin: '你赢了！',
  finaleCpuWin: 'CPU 获胜！',
  finaleFive: '达成 5 连！',
  finaleTerritory: '领地之争！',
  winnerAlt: '获胜者',
  loadingBoot: '启动中...',
  loadingConnect: '连接中...',
  loadingProfile: '正在读取资料...',
  loadingAssets: '正在读取资源...',
  loadingReady: '准备就绪',
  reauthRequiredTitle: '需要重新登录',
  startupFailedTitle: '启动失败',
  reauthButton: '重新登录',
  reloadButton: '重新读取',
  lineReloginButton: 'LINE 重新登录',
  reauthReason: '登录已过期。请重新登录。',
  errorReauth: '登录已过期。请重新登录。',
  errorForbidden: '你没有权限使用此游戏。',
  errorNotFound: '未找到游戏数据。',
  errorRateLimited: '通信频繁，请稍后再试。',
  errorServer: '无法连接到服务器。请稍后重新读取。',
  errorCommunication: '发生通信错误。请重新读取。',
  errorNetwork: '无法连接到网络。请检查网络状态并重新读取。',
  errorStartup: '启动失败。请重新读取。',
  settingsTabGeneral: '设置',
  settingsTabAccount: '账号',
  settingsTabInfo: '信息',
  account: '账号',
  linked: '已关联',
  guest: '游客',
  loggedInWith: '已通过 {provider} 账号登录',
  loggedIn: '已登录账号',
  playingAsGuest: '当前正以游客身份游戏。',
  appleLoginBusy: '正在登录 Apple...',
  appleLogin: '通过 Apple 登录',
  googleLoginBusy: '正在登录 Google...',
  googleLogin: '通过 Google 登录',
  logoutBusy: '正在注销...',
  logout: '注销',
  logoutSuccess: '已成功注销',
  logoutFailed: '注销失败',
  appInfo: '应用信息',
  appName: '应用名称',
  version: '版本',
  legalInfo: '法律信息',
  terms: '使用条款',
  privacy: '隐私政策',
  operator: '运营者',
  contact: '联系我们',
  copyTap: '点击复制',
  idCopied: 'ID 已复制',
  copyFailed: '复制失败',
  other: '其他',
  reportAd: '举报不当广告',
  privacyChoices: 'Ad privacy choices',
  profileEdit: '编辑资料',
  displayName: '显示名称',
  displayNamePlaceholder: '输入名称',
  chooseIcon: '选择头像',
  iconLoadFailed: '无法获取头像列表。',
  saveFailed: '保存失败。请重试。',
  noIcons: '没有可用的头像。',
  save: '保存',
  saving: '正在保存...',
  staminaAria: '体力值 {stamina} / {max}',
  nextRecovery: '距离下次恢复还有 {time}',
  adPlaying: '广告播放中...',
  recoverFullAd: '看广告完全恢复体力',
  dailyBonusAria: '看完整个广告获得体力+5',
  dailyBonusAd: '看广告获得体力+5',
  legalLastUpdated: '最后更新日期：{date}',
  privacyTitle: '隐私政策',
  termsTitle: '使用条款',
  adPlayingAria: '正在播放广告',
  adBadge: '▶ 广告',
  adRemaining: '剩余 {seconds} 秒',
  adDevHint: '※ 这是开发用的模拟广告。在正式版中将播放 AdMob 视频广告。',
  adRewardRequirement: '看完整个广告即可获得以下奖励。',
  adRewardStaminaDetail: '奖励：体力恢复到上限',
  adRewardDailyBonusDetail: '奖励：今日一次性奖励体力 +{amount}',
  adRewardIncompleteNote: '中途关闭将无法获得奖励。',
  adSkipAria: '跳过广告',
  adSkip: '跳过 ✕',
  adSkipAfter: '{seconds} 秒后可跳过',
  offlineMessage: '无法连接到服务器。部分功能可能无法使用。',
  reconnecting: '正在重新连接...',
  reconnect: '重新连接',
  signInTitle: '登录',
  signInBusy: '正在登录...',
  signInCancelNote: '取消登录后将继续以游客身份游玩（部分功能将受限）。',
  processing: '处理中...',
  recoverConfirmTitle: '数据覆盖确认',
  recoverConfirmMessage: '该登录账号下已有数据。继续操作将替换当前设备上的游客数据。确定要继续吗？',
  recoverConfirmContinue: '覆盖并继续',
  recoverConfirmCancel: '取消',
  unlinkConfirmTitle: '解除关联',
  unlinkConfirmMessage: '解除与此平台的关联后，此设备将返回游客状态。如果您在其他设备上使用相同平台登录，Hub 上的数据依然保留。',
  unlinkConfirmContinue: '解除关联',
  unlinkConfirmCancel: '取消',
  deleteConfirmTitle: '确认注销账号',
  deleteConfirmMessage: '删除账号将丢失所有最高分、登录信息、关联账号及邀请关系。\n此操作不可撤销。确定要注销吗？',
  deleteConfirmContinue: '注销账号',
  deleteConfirmCancel: '取消',
  adNekoTitle: '广告猫',
  matchmakingRemaining: '剩余 {seconds} 秒',
  matchmakingTimeoutMessage: '未能在时间内找到对手。请再试一次。',
  difficultyEasyName: '入门',
  difficultyEasyDescription: '对手看起来有点心不在焉',
  difficultyNormalName: '普通',
  difficultyNormalDescription: '对手偶尔会犯点小错误',
  difficultyHardName: '困难',
  difficultyHardDescription: '对手的视野非常开阔',
  difficultyHellName: '狂暴',
  difficultyHellDescription: '对手非常强大，且精于预判',
}
